export const LIBERTY_MUTUAL_DOMAIN = 'libertymutual.com'
export const FLOWCODE_DOMAIN = 'flowcode.com'
export const BOISE_STATE_DOMAIN = 'boisestate.edu'
export const KRAFT_HEINZ_DOMAIN = 'kraftheinz.com'
export const PRINCE_WILLIAM_COUNTY_DOMAIN = 'pwcgov.org'

const STANFORD_HEALTH_DOMAIN = 'stanfordhealthcare.org'
const LAKERS_DOMAIN = 'la-lakers.com'
const ABC_DOMAIN = 'abc.com'
const ST_JUDES_DOMAIN = 'alsac.stjude.org'
const CORCORAN_DOMAIN = 'corcoran.com'
const GRIZZLIES_DOMAIN = 'grizzlies.com'
const MOONPAY_DOMAIN = 'moonpay.com'
const INNOVID_DOMAIN = 'innovid.com'
const VOYA_DOMAIN = 'voya.com'
const TEST_FLOWCODE_DOMAIN = 'fl0wc.de'
const TEST_DTX_LABS_DOMAIN = 'dtxlabs.onmicrosoft.com'

export const SSO_ENABLED_EMAILS = [
  VOYA_DOMAIN,
  TEST_FLOWCODE_DOMAIN,
  TEST_DTX_LABS_DOMAIN,
  LAKERS_DOMAIN,
  ABC_DOMAIN,
  STANFORD_HEALTH_DOMAIN,
  ST_JUDES_DOMAIN,
  CORCORAN_DOMAIN,
  GRIZZLIES_DOMAIN,
  MOONPAY_DOMAIN,
  INNOVID_DOMAIN
]

export const POPUP_CLOSED_BY_USER = 'auth/popup-closed-by-user'
